import { render, staticRenderFns } from "./DrawerEmailForm.vue?vue&type=template&id=68f080f1&scoped=true"
import script from "./DrawerEmailForm.vue?vue&type=script&lang=js"
export * from "./DrawerEmailForm.vue?vue&type=script&lang=js"
import style0 from "./DrawerEmailForm.vue?vue&type=style&index=0&id=68f080f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f080f1",
  null
  
)

export default component.exports